import { MathOperatorsStep } from '../actionSectionTypes';
import { TargetFieldVariable } from './types';

const checkVariableDeleted = (
  value: TargetFieldVariable,
  variableName: string
) => value.value === variableName;

export const mathOperatorsRemoveVariable = (
  step: MathOperatorsStep,
  variableName: string
) => {
  let hasError = step.hasError || false;
  const nextErrorIds: string[] = [];
  let nextStep = { ...step, hasError: true };

  const subType = step.details.subType;
  if (
    step.details.simpleData[subType].targetField!.isVariable &&
    step.details.simpleData[subType].targetField!.value === variableName
  ) {
    if (!nextErrorIds.includes(step.id)) {
      hasError = true;
      nextErrorIds.push(step.id);
    }
    nextStep = {
      ...nextStep,
      details: {
        ...nextStep.details,
        simpleData: {
          ...step.details.simpleData,
          [subType]: {
            ...step.details.simpleData[subType],
            targetField: {
              ...step.details.simpleData[subType].targetField,
              deleted: true,
            } as TargetFieldVariable,
          },
        },
      },
    };
  }

  if (subType === 'addition') {
    const elements = step.details.simpleData.addition.elements.map(
      (element) => {
        if (
          element.argumentType === 'variable' &&
          checkVariableDeleted(
            element.value as TargetFieldVariable,
            variableName
          )
        ) {
          if (!nextErrorIds.includes(step.id)) {
            hasError = true;
            nextErrorIds.push(step.id);
          }

          return {
            ...element,
            value: { ...(element.value as TargetFieldVariable), deleted: true },
          };
        }

        return element;
      }
    );

    nextStep = {
      ...nextStep,
      details: {
        ...nextStep.details,
        simpleData: {
          ...nextStep.details.simpleData,
          addition: {
            ...nextStep.details.simpleData.addition,
            elements,
          },
        },
      },
    };
  } else {
    const denominatorElements =
      step.details.simpleData.multiplication.denominatorElements.map(
        (element) => {
          if (
            element.argumentType === 'variable' &&
            checkVariableDeleted(
              element.value as TargetFieldVariable,
              variableName
            )
          ) {
            if (!nextErrorIds.includes(step.id)) {
              hasError = true;
              nextErrorIds.push(step.id);
            }

            return {
              ...element,
              value: {
                ...(element.value as TargetFieldVariable),
                deleted: true,
              },
            };
          }

          return element;
        }
      );

    const numeratorElements =
      step.details.simpleData.multiplication.numeratorElements.map(
        (element) => {
          if (
            element.argumentType === 'variable' &&
            checkVariableDeleted(
              element.value as TargetFieldVariable,
              variableName
            )
          ) {
            if (!nextErrorIds.includes(step.id)) {
              hasError = true;
              nextErrorIds.push(step.id);
            }

            return {
              ...element,
              value: {
                ...(element.value as TargetFieldVariable),
                deleted: true,
              },
            };
          }

          return element;
        }
      );

    nextStep = {
      ...nextStep,
      details: {
        ...nextStep.details,
        simpleData: {
          ...nextStep.details.simpleData,
          multiplication: {
            ...nextStep.details.simpleData.multiplication,
            denominatorElements,
            numeratorElements,
          },
        },
      },
    };
  }

  return {
    nextStep: {
      ...nextStep,
      hasError,
    },
    nextErrorIds,
  };
};
